import pako from 'pako'

export default {
  handleRemoveSessionStorage(sessionKey: string) {
    sessionStorage.removeItem(sessionKey)
  },
  handleSetSessionStorage(sessionKey: string, sessionTargetData: any) {
    this.handleRemoveSessionStorage(sessionKey)

    const setSessionTargetData = JSON.stringify(sessionTargetData)

    const commpressSetSessionTargetData = pako.deflate(
      setSessionTargetData
    ) as Uint8Array

    try {
      sessionStorage.setItem(sessionKey, String(commpressSetSessionTargetData))
      return true
    } catch (err) {
      console.log(err)
      return false
    }
  },
  handleGetSessionStorage(sessionKey: string) {
    try {
      if (sessionStorage.getItem(sessionKey) === null) return ''
      const getSessionData = sessionStorage
        .getItem(sessionKey)
        ?.split(',') as Iterable<number>

      const decompressGetSessionData = JSON.parse(
        pako.inflate(new Uint8Array(getSessionData), { to: 'string' })
      )

      return decompressGetSessionData
    } catch (err) {
      console.log(err)
      // return false
      // URIデコードでfalseが文字列判定されるため、空文字を返却する
      return ''
    }
  },
  handleGetAllSessionStorage() {
    const getAllSessionData = Object.keys(sessionStorage)
      .map(sessionKey => {
        const obj = {} as { [key: string]: any }
        const getSessionData = this.handleGetSessionStorage(sessionKey)

        if (getSessionData) {
          obj[sessionKey] = getSessionData
          return obj
        }
      })
      .filter(value => value !== undefined)

    return getAllSessionData
  },
}
